import styled from "@emotion/styled";

import { Box } from "metabase/ui";

export const QuestionPickerContainer = styled(Box)`
  height: 600px;
  overflow-y: auto;
`;
